<template>
    <div>
        <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                    <small>{{ $t('auth.login-message') }}</small>
                </div>
                <validation-observer v-slot="{ invalid, handleSubmit }" ref="loginValidator">
                    <form role="form" @submit.prevent="handleSubmit(login)">

                        <base-input alternative
                            name="username"
                            :rules="{required: true}"
                            prepend-icon="tim-icons icon-single-02"
                            :placeholder="$t('auth.username-placeholder')"
                            v-model="form.username"
                            class="mb-3"
                        >
                        </base-input>

                        <base-input alternative
                            type="password"
                            name="password"
                            :rules="{required: true, min: 8}"
                            prepend-icon="tim-icons icon-access-key"
                            :placeholder="$t('auth.password-placeholder')"
                            v-model="form.password"
                            class="mb-3"
                        >
                        </base-input>

                        <p class="error mb-3 text-center" v-if="error">
                            {{ error }}
                        </p>
                        
                        <div class="text-center pt-2">
                            <base-button type="primary"
                                native-type="submit"
                                :disabled="invalid"
                            >
                                {{ $t('auth.log-in') }}
                            </base-button>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <router-link to="/astral/ui/reset-password" class="text-light">
                    <small>{{ $t('auth.forgot-password') }}</small>
                </router-link>
            </div>
            <div class="col-6 text-right">
                <a href="mailto:astral@enac.fr" class="text-light">
                    <small>{{ $t('common.contact') }}</small>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            endpoint: {
                type: String,
                default: '/trax/api/auth/login'
            },
        },

        data() {
            return {
                form: {
                    username: null,
                    password: null
                },
                error: null
            }
        },

        methods: {
            login() {
                this.error = null
                axios.post(this.endpoint, this.form)
                    .then(resp => {
                        let target = this.$auth.redirect() ? this.$auth.redirect() : { name: 'home' }
                        this.$router.push(target)
                        .catch(err => {
                            // This may happen when we need to do something before accessing to the home page.
                            // And this is normal. Nothing to do.
                        })
                    })
                    .catch(err => {
                        switch(err.response.status) {
                            case 503:
                                this.$router.push({ name: 'maintenance' })
                                break
                            case 401:
                            case 422:
                                this.error = this.$t('auth.login-error')
                                break
                            default:
                                this.error = this.$t('auth.login-unknown-error')
                                break;
                        }
                    })
            }
        }
    }
</script>

<style scoped>

    .error {
        font-size: 80%;
        color: #fb6340;
        font-weight: 400;
    }

</style>
